import React from "react";
import SvgClose from "../../assets/icons/SvgClose";
import Header from "./Header";
import Form from "./Form";
import { graphql, useStaticQuery } from "gatsby";

const Popup = ({ isOpen, closePopup }) => {
  const { contentfulBushbuckClub } = useStaticQuery(graphql`
    {
      contentfulBushbuckClub {
        title
        headerDescription {
          raw
        }
        headerImage {
          title
          gatsbyImageData(
            layout: FULL_WIDTH
            formats: WEBP
            placeholder: DOMINANT_COLOR
          )
        }
        headerClubFeatures {
          title
          image {
            title
            gatsbyImageData(
              layout: FULL_WIDTH
              formats: WEBP
              placeholder: DOMINANT_COLOR
            )
          }
        }
        clubBenefits {
          title
          icon: backgroundImage {
            title
            gatsbyImageData(
              layout: FULL_WIDTH
              formats: WEBP
              placeholder: DOMINANT_COLOR
            )
          }
        }
      }
    }
  `);
  return (
    <div
      className={`fixed w-screen h-[130vh] inset-0 z-20 bg-black/40 flex items-start justify-center overflow-hidden ${
        isOpen ? "block" : "hidden"
      }`}
    >
      <div className="absolute top-10 left-1/2 -translate-x-1/2 w-full h-[110vh] flex flex-col bg-white max-w-[80rem] z-[11] overflow-y-auto ">
        <div
          onClick={closePopup}
          className="absolute top-[10px] right-[10px] cursor-pointer rounded-full text-white w-10 h-10 hover:text-secondary-500 text-base
            flex items-center justify-center z-[2]"
        >
          <SvgClose />
        </div>
        <Header
          description={contentfulBushbuckClub.headerDescription}
          backgroundImage={contentfulBushbuckClub.headerImage}
          features={contentfulBushbuckClub.headerClubFeatures}
        />
        <Form />
      </div>
    </div>
  );
};

export default Popup;
